(function ($) {
	$.fn.card = function () {
		let $el;
		let $blanket;
		let $bottomSpace;
		// let $header;
		let $title;
		// let $content;
		let backgroundImg;
		let $cardMinHeight;
		let windowHeight;

		const init = function () {
			// Fill up the variables.
			$blanket = $el.find('.card__blanket');
			// $header = $el.find('.card__icon'); // I know, it's a stupid class.
			$title = $el.find('.card__title');
			// $content = $el.find('.card__content');
			$cardMinHeight = parseInt($el.css('min-height'));
			$bottomSpace = $cardMinHeight;

			// Detect if card has the background attached.
			if ($el.find('.card__background').length) {
				backgroundImg = $el.find('.card__background');

				$el.on('mousemove', function (event) {
					$el.addClass('hovering');

					const relX = event.pageX - $(window).scrollLeft();
					const relY = event.pageY - $(window).scrollTop();

					backgroundImg
						.css({
							top: relY - backgroundImg.height() / 2,
							left: relX - backgroundImg.width() / 2,
						})
						.addClass('is-visible');
				});

				$el.on('mouseleave', function () {
					$el.removeClass('hovering');
					backgroundImg.removeClass('is-visible');
				});
			}

			// Detect if card is in the expandable mode.
			if ($el.hasClass('card--expandable')) {
				updateWindowHeight();

				workBlanket();
				animateContent();
				updateBlanketColour();

				$(window).on('scroll', function () {
					updateWindowHeight();

					workBlanket();
					animateContent();
					updateBlanketColour();
				});

				$(window).on('resize', function () {
					updateWindowHeight();

					workBlanket();
					animateContent();
					updateBlanketColour();
				});
			}
		};

		const workBlanket = function () {
			const $windowBottomEdge = $(window).scrollTop() + windowHeight;
			const $cardOffsetTop = $el.offset().top;

			// If the bottom edge of the window is within the card...
			// then manipulate the blanket.
			if (
				$windowBottomEdge >= $cardOffsetTop + $cardMinHeight + $bottomSpace &&
				$windowBottomEdge <= $cardOffsetTop + $el.height() + $bottomSpace
			) {
				$blanket.css({
					top: $windowBottomEdge - $cardOffsetTop - $bottomSpace - $cardMinHeight,
				});
			}

			// This fixes glitches when you scroll fast past the element
			if ($windowBottomEdge > $cardOffsetTop + $el.height() + $bottomSpace) {
				$blanket.css({
					top: '100%',
				});
			}
		};

		const animateContent = function () {
			const $windowBottomEdge = $(window).scrollTop() + windowHeight;
			const $cardOffsetTop = $el.offset().top;

			// Trigger points.
			const triggerPoints = {
				header: 128 + $title.height() + $bottomSpace,
				content: 128 + $title.height() + parseInt($title.css('margin-top')) + $bottomSpace * 2,
			};

			// Animation trigger points.
			$.each(triggerPoints, function (key, value) {
				if ($windowBottomEdge - $cardOffsetTop > value) {
					$el.addClass('animate-' + key);
				} else {
					$el.removeClass('animate-' + key);
				}
			});
		};

		const updateWindowHeight = function () {
			windowHeight = window.innerHeight;
		};

		const updateBlanketColour = function () {
			$blanket.css('background-color', $('#page').css('background-color'));
		};

		if (this.length > 0) {
			if (this.length > 1) {
				this.each(function () {
					$(this).card();
				});
			} else {
				$el = this;
				init();
			}
		}
	};

	$(document).ready(function () {
		$('.card').card();
	});
})(jQuery);
